import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-family-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-family-cm.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { CreateApplicationFamilyCmConstants } from "./create-application-family-cm.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationFamilyCmComponent = class CreateApplicationFamilyCmComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    applicationService;
    changeDetectorRefs;
    familyForm;
    validationMessages = CreateApplicationFamilyCmConstants.VALIDATION_MESSAGES;
    familyFormControlName = CreateApplicationFamilyCmConstants.FAMILY_FORM_CONTROL_NAME;
    familyLabel = CreateApplicationFamilyCmConstants.FAMILY_LABEL;
    copyApplicantToFamilyLabel = CreateApplicationFamilyCmConstants.COPY_APPLICANT_TO_FAMILY_LABEL;
    familyDisableFilterBy = true;
    familyDisableAdd = false;
    familyDisableEditing = false;
    familyGroups = [];
    familyListLabel = "Family";
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, applicationService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.applicationService = applicationService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        if (this.applicationService.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.familyGroups = this.recipientListService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
        }
        else {
            this.getMetadata();
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("familyForm");
        this.familyForm = form;
    }
    loadMetadata(stepMeta) {
        this.familyGroups = stepMeta.familyGroup;
        if (this.familyGroups[0].hasOwnProperty("requiredFields") && this.familyGroups[0].requiredFields !== null) {
            this.familyGroups = this.recipientListService.checkStepMetaRecipientGroups(this.familyGroups);
        }
    }
    getFamilyControl() {
        return this.familyForm.get(this.familyFormControlName);
    }
    onBtnCopyApplicantToFamilyClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const familyFormControl = this.getFamilyControl();
        this.recipientListService.addRecipient(applicant, true, familyFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationFamilyCmComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-family-cm",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationFamilyCmComponent);
export { CreateApplicationFamilyCmComponent };
